import { Controller } from "@hotwired/stimulus"
import { formatTND } from "../lib/currency"

export default class extends Controller {
  static targets = ["select", "price", "promoPrice", "priceBlock"]

  updatePrice(event) {
    const selectedOption = event.target.options[event.target.selectedIndex]
    const normalPrice = selectedOption.value
    const promoPrice = selectedOption.dataset.promoPrice
    const badge = selectedOption.dataset.discountBadge
    const size = selectedOption.dataset.size
    const effectivePrice = promoPrice || normalPrice
    // "" (vide) si pas de promo = illimité ; sinon la quantité restante au
    // prix promo pour CETTE taille.
    const maxQuantity = promoPrice ? (selectedOption.dataset.promoRemaining || "") : ""

    this.renderPrice(normalPrice, promoPrice, badge)
    this.updateCountdown(selectedOption)

    // Mettre à jour le data-attribute du bouton "Ajouter au panier"
    const addButton = document.querySelector('[data-action*="addToCart"]')
    if (addButton) {
      addButton.dataset.parfumPrice = effectivePrice
      addButton.dataset.parfumSize = size
      addButton.dataset.parfumMaxQuantity = maxQuantity
    }

    // Mettre à jour le bouton "Acheter maintenant" aussi
    const buyButton = document.querySelector('[data-action*="buyNow"]')
    if (buyButton) {
      buyButton.dataset.parfumPrice = effectivePrice
      buyButton.dataset.parfumSize = size
    }
  }

  renderPrice(normalPrice, promoPrice, badge) {
    if (!this.hasPriceBlockTarget) return

    if (promoPrice) {
      this.priceBlockTarget.innerHTML = `
        <span class="flash-price-badge">${badge || "PROMO"}</span>
        <span class="flash-price-old">${this.formatCurrency(normalPrice)}</span>
        <span class="flash-price-now">${this.formatCurrency(promoPrice)}</span>
      `
    } else {
      this.priceBlockTarget.innerHTML = `
        <span class="vitrine-parfum-detail-price">${this.formatCurrency(normalPrice)}</span>
      `
    }
  }

  updateCountdown(selectedOption) {
    const countdownEl = document.querySelector('[data-controller~="flash-sale-countdown"]')
    const endsAt = selectedOption.dataset.flashSaleEndsAt

    if (!countdownEl) return

    // Écrire via dataset modifie le même attribut
    // data-flash-sale-countdown-ends-at-value : c'est cette mutation qui
    // déclenche endsAtValueChanged() côté contrôleur du compte à rebours.
    if (selectedOption.dataset.promoPrice && endsAt) {
      countdownEl.hidden = false
      countdownEl.dataset.flashSaleCountdownEndsAtValue = endsAt
    } else {
      countdownEl.hidden = true
      delete countdownEl.dataset.flashSaleCountdownEndsAtValue
    }
  }

  formatCurrency(amount) {
    return formatTND(amount)
  }
}
